// @flow
import { put, takeEvery, call } from 'redux-saga/effects';

import api from '@api';
import { EmailTemplatesListResType } from '../../types/emailTemplate';
import { getEmailTemplatesListFetchFailure, getEmailTemplatesListFetchSuccess } from './reducer';

const getEmailTemplatesRequest = async () => {
    const res = await api('get', `api/secure/email-templates`);
    return res.data.data;
};

export function* getEmailTemplatesFetch(): any {
    try {
        const response: EmailTemplatesListResType = yield call((): any => getEmailTemplatesRequest());
        yield put(getEmailTemplatesListFetchSuccess(response));
    } catch (error) {
        yield put(getEmailTemplatesListFetchFailure(error));
    }
}

export function* getEmailTemplatesListFetchWatch() {
    yield takeEvery('emailTemplatesList/getEmailTemplatesListFetch', getEmailTemplatesFetch);

}
